<template>
  <div>
    <logout-confirmation v-if="getterPopupName === 'LogoutConfirmation'"
                        :sessionOptions="sessionOptions" :userId="user.id"
                        @refreshUserSessions="refreshUserSessions" />

    <div class="table-head" v-if="isDesktop()">
      <p class="d-left">Last login</p>
      <p>IP address</p>
      <p>OS</p>
      <p>Browser</p>
      <p></p>
    </div>

    <table-loader v-if="!sessionsAdded" />

    <div class="table-empty" v-else-if="sessionsList.length === 0">
      <p>No Active Sessions found</p>
    </div>

    <div class="table-body" v-else>
      <div class="table-row" v-for="(session, index) in sessionsList" :key="index">
        <p class="d-left no-wrap">
          <b v-if="!isDesktop()">Last login:</b>
          {{session.login_time | loginTime}}
        </p>
        <p>
          <b v-if="!isDesktop()">IP address:</b>
          {{session.login_ip}}
        </p>
        <p>
          <b v-if="!isDesktop()">OS:</b>
          {{session.device_os}}
        </p>
        <p>
          <b v-if="!isDesktop()">Browser:</b>
          {{session.device_app}}
        </p>
        <p class="mt-grey-text">
          <span v-if="session.current_session">Current Session</span>
          <button v-else-if="showLogout" class="delete" @click="confirmLogout(session, index)">
            <i class="fa fa-sign-out-alt" />Logout
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LogoutConfirmation from '@/components/Settings/UserProfile/LogoutConfirmation'
import TableLoader from '@/components/global/TableLoader'

import { openPopup } from '@/utils/helpers'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'UserSessions',
  components: { LogoutConfirmation, TableLoader },
  props: {
    userSessions: Array,
    user: {
      type: Object,
      default: () => {
        return {
          id: null
        }
      }
    },
    sessionsAdded: Boolean
  },
  data () {
    return {
      sessionOptions: {},
      sessionsList: [],
      showLogout: true
    }
  },
  computed: {
    ...mapGetters(['getterPopupName'])
  },
  watch: {
    userSessions: {
      handler: 'populateData'
    }
  },
  filters: {
    loginTime (time) {
      let diff = moment().diff(moment(time), 'days')
      if (diff === 1) {
        return `Yesterday at ${moment(time).format('hh:mm a')}`
      } else if (diff === 0) {
        return `Today at ${moment(time).format('hh:mm a')}`
      } else {
        return moment(time).format('DD-MMM-YYYY, hh:mm a')
      }
    }
  },
  methods: {
    openPopup,
    populateData () {
      this.sessionsList = this.userSessions.slice()
      let currentSessionIndex = this.sessionsList.findIndex(el => el.current_session)
      this.sessionsList.unshift(this.sessionsList[currentSessionIndex])
      this.sessionsList.splice(currentSessionIndex + 1, 1)

      if (this.$route.name === 'UserDetails') {
        this.showLogout = this.user.manageAccess
      }
    },
    confirmLogout (session, index) {
      this.sessionOptions = {
        ...session,
        index: index
      }
      this.openPopup('LogoutConfirmation')
    },
    refreshUserSessions () {
      this.openPopup(null)
      this.sessionsList.splice(this.sessionOptions.index, 1)
      this.$emit('refreshUserSessions', this.sessionsList)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/settingsTable.scss';

  .table-row, .table-head {
    p {
      span {
        color: $grey-light;
      }
      .delete {
        @include normal-text($primary, 14px);
        text-decoration: underline;

        i {
          margin-right: 5px;
        }
      }
    }
  }

  .table-empty {
    margin: 10px 0;
    text-align: center;
  }

  .desktop {
    .table-row, .table-head {
      grid-template-columns: 28% 18% 18% 12% 24% !important;
      cursor: default !important;

      p {
        &:not(.d-left) {
          text-align: center;
        }
        &.no-wrap {
          white-space: nowrap;
        }
      }
    }
  }

  .tablet, .mobile {
    .table-row {
      grid-template-areas: "time time"
                        "os ip"
                        "app logout";

      p {
        &:nth-child(1) {
          grid-area: time;
        }
        &:nth-child(2) {
          grid-area: ip;
          text-align: right;
        }
        &:nth-child(3) {
          grid-area: os;
        }
        &:nth-child(4) {
          grid-area: app;
        }
        &:nth-child(5) {
          grid-area: logout;
          text-align: right;
        }
      }
    }
  }
</style>
